import { defineStore } from 'pinia'

export default defineStore({
  id: 'inbox',
  state: () => ({
    activeContact: null,
    readContacts: [],
  })
});